/* eslint-disable no-plusplus */

import { Images } from '../../../../../../../shared/app-constants';

export const editViewOptions = [
  {
    key: 'private',
    text: 'Private (Only me)',
    isShared: false,
  },
  {
    key: 'public',
    text: 'Public (Everyone)',
    isShared: true,
  },
];

export const transformAppliedSavedFilters = (filters) => {
  const transformedFilters = filters.map((filter) => filter.id);

  return transformedFilters;
};

export const getViewList = (savedFilters, searchQuery = '') =>
  savedFilters.reduce(
    (acc, filter) => {
      // Normalize both filter name and search query for case-insensitive comparison
      const normalizedFilterName = filter.filterName.toLowerCase();
      const normalizedSearchQuery = searchQuery.toLowerCase();

      // Check if the search query is empty or the filter name includes the search query
      if (
        normalizedSearchQuery === '' ||
        normalizedFilterName.includes(normalizedSearchQuery)
      ) {
        if (filter.isShared) {
          acc.public.push(filter);
        } else {
          acc.private.push(filter);
        }
      }

      return acc;
    },
    { public: [], private: [] },
  );

export const getSavedViewDefaultClassNames = () =>
  'saved-filters__item d-flex align-items-center pointer regular-1 font-medium gray-txt-15 line-height-20';

export const VISIBILITY_OPTIONS = [
  {
    key: 'private',
    label: 'Private Note',
    description: 'Visible only to you and people tagged here',
    icon: Images.LockGolden,
  },
  {
    key: 'public',
    label: 'Public Note',
    description: 'Visible to everyone in the organisation',
    icon: Images.LockOpenGreen,
  },
];
